export default __webpack_public_path__ + "static/media/card.1dcba0fb.png";